import { render, staticRenderFns } from "./hgt.vue?vue&type=template&id=38a40767&scoped=true"
import script from "./hgt.vue?vue&type=script&lang=js"
export * from "./hgt.vue?vue&type=script&lang=js"
import style0 from "./hgt.vue?vue&type=style&index=0&id=38a40767&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a40767",
  null
  
)

export default component.exports